'use client'

import { ImageWrapper } from '@/components/image'
import type { SitePopup } from '@/lib/popups/types'
import { cx } from '@/lib/utils'

export const GeneralPopupImage = ({ popup }: { popup: SitePopup }) => {
  if (!popup.imageUrl) {
    return null
  }

  return (
    <div
      className={cx(
        'relative aspect-[3/2] overflow-hidden rounded-xl',
        popup.imagePadded && 'bg-slate-100 shadow-inner'
      )}
    >
      <div className={cx('flex h-full w-full items-center justify-center', popup.imagePadded && 'p-6')}>
        <ImageWrapper
          image={popup.imageUrl}
          imgProps={{
            alt: popup.imageAlt ?? '',
            className: cx('h-full w-full', popup.imagePadded ? 'object-contain' : 'object-cover'),
            decoding: 'async',
          }}
          sizingProps={{
            maxWidth: Math.min(popup.imageWidth ?? 640, 640),
            sizes: '(min-width: 768px) 256px, calc(100vw - 5rem)',
          }}
          origin="general-site-popup"
          loadTime="lazy"
          blockRobots
        />
      </div>
    </div>
  )
}
